import { STEP } from './steps';

export const hasPreviousStep = (step: number, lastStep: number) => {
  if (step > 1 && step <= lastStep) return true;
  return false;
};

export const hasNextStep = (step: number, lastStep: number) => {
  if (step <= lastStep) return true;
  return false;
};

export const verifyStepDetails = (
  touched: any,
  errors: any,
  currentStep: number
): boolean => {
  if (currentStep === STEP.ACCOUNT_DETAILS) {
    if (!touched.displayName || !touched.username) return true;
    return errors.displayName || errors.username;
  } else if (currentStep === STEP.ACCOUNT_AUTH) {
    if (!touched.email || !touched.password || !touched.passwordVerification)
      return true;
    return errors.email || errors.password || errors.passwordVerification;
  } else if (currentStep === STEP.PERSONAL_DETAILS) {
    if (!touched.name) return true;
    return errors.name || errors.phone;
  }
  return false;
};
